/* eslint-disable max-lines */
import { css } from 'styled-components';
import { CFBaseButtonTokens } from '../';
import { hoverTextEffect } from './label';
export const rootFocusOutlineEffect = ({ $disabled, $focused, $variant, }) => {
    let outlineColor, outlineOffset;
    switch ($variant) {
        case 'control':
        case 'control-active':
        case 'control-alternate':
        case 'secondary-alternate':
        case 'success-secondary':
        case 'success-secondary-alternate':
        case 'danger-secondary':
        case 'danger-secondary-alternate':
            outlineOffset = 0;
            break;
        default:
            outlineOffset = 4;
            break;
    }
    switch (true) {
        case !$focused:
            outlineColor = 'transparent';
            break;
        case $disabled:
            outlineColor = CFBaseButtonTokens.COLORS.FOCUS.DISABLED;
            break;
        case $variant === 'boost-alternate':
            outlineColor = CFBaseButtonTokens.COLORS.FOCUS.BOOST_ALTERNATE;
            break;
        case $variant === 'control':
            outlineColor = CFBaseButtonTokens.COLORS.FOCUS.CONTROL;
            break;
        case $variant === 'control-alternate':
            outlineColor = CFBaseButtonTokens.COLORS.FOCUS.CONTROL_ALTERNATE;
            break;
        case $variant === 'emphasis':
        case $variant === 'emphasis-tertiary':
        case $variant === 'standalone-emphasis':
            outlineColor = CFBaseButtonTokens.COLORS.FOCUS.EMPHASIS;
            break;
        case $variant === 'danger':
        case $variant === 'danger-secondary':
        case $variant === 'danger-tertiary':
            outlineColor = CFBaseButtonTokens.COLORS.FOCUS.DANGER;
            break;
        case $variant === 'danger-secondary-alternate':
        case $variant === 'danger-tertiary-alternate':
            outlineColor = CFBaseButtonTokens.COLORS.FOCUS.DANGER_ALTERNATE;
            break;
        case $variant === 'success':
        case $variant === 'success-secondary':
        case $variant === 'success-tertiary':
            outlineColor = CFBaseButtonTokens.COLORS.FOCUS.SUCCESS;
            break;
        case $variant === 'success-secondary-alternate':
        case $variant === 'success-tertiary-alternate':
            outlineColor = CFBaseButtonTokens.COLORS.FOCUS.SUCCESS_ALTERNATE;
            break;
        case $variant === 'danger-alternate':
        case $variant === 'control-active-alternate':
        case $variant === 'primary-alternate':
        case $variant === 'secondary-alternate':
        case $variant === 'standalone-alternate':
        case $variant === 'success-alternate':
        case $variant === 'tertiary-alternate':
            outlineColor = CFBaseButtonTokens.COLORS.FOCUS.ALTERNATE;
            break;
        default:
            outlineColor = CFBaseButtonTokens.COLORS.FOCUS.DEFAULT;
            break;
    }
    return css `
    outline-color: ${outlineColor};
    outline-offset: ${outlineOffset}px;
    outline-style: solid;
    outline-width: 2px;
  `;
};
export const rootHoverBackgroundEffect = ($disabled, $variant) => {
    const backgroundColor = $disabled
        ? CFBaseButtonTokens.COLORS.BACKGROUND_DISABLED[$variant]
        : CFBaseButtonTokens.COLORS.BACKGROUND_HOVER[$variant];
    return css `
    background-color: ${backgroundColor};
  `;
};
export const rootHoverBorderEffect = ($disabled, $variant) => {
    if ($disabled)
        return null;
    switch ($variant) {
        case 'control':
            return css `
        border-color: ${CFBaseButtonTokens.COLORS.BORDER['secondary']};
      `;
        case 'control-alternate':
            return css `
        border-color: ${CFBaseButtonTokens.COLORS.BORDER['secondary-alternate']};
      `;
        default:
            return null;
    }
};
export const rootNativeInteractions = ({ $disabled, $focused, $pressed, $variant, }) => {
    return css `
    ${$pressed && rootHoverBackgroundEffect($disabled, $variant)}
    ${$focused && rootFocusOutlineEffect({ $disabled, $focused, $variant })}
  `;
};
export const rootWebInteractions = ({ $disabled, $variant, }) => {
    return css `
    transition-property: outline-color, background-color;
    transition-timing-function: linear;
    transition-duration: 200ms;

    &:hover {
      color: inherit;
      ${rootHoverBackgroundEffect($disabled, $variant)}
      ${rootHoverBorderEffect($disabled, $variant)}

      svg {
        path {
          fill: ${hoverTextEffect($disabled, $variant).textColorValue};
        }
      }
    }

    a:focus-visible &,
    button:focus-visible & {
      color: inherit;
      ${rootFocusOutlineEffect({ $disabled, $focused: true, $variant })}
    }

    a:focus-visible[aria-disabled='true'] &,
    button:focus-visible[aria-disabled='true'] & {
      color: inherit;
      ${rootFocusOutlineEffect({ $disabled: true, $focused: true, $variant })}
    }

    a:disabled &,
    button:disabled &,
    a:focus-visible[aria-disabled='true'] &,
    button:focus-visible[aria-disabled='true'] & {
      pointer-events: none;
    }

    ${$disabled &&
        css `
      pointer-events: none;
    `};
  `;
};
export const wrapperInteractions = ({ $disabled }) => {
    return css `
    outline-width: 0;
    ${$disabled
        ? css `
          pointer-events: none;
        `
        : null}
  `;
};
